module.exports = __webpack_public_path__ + "img/female-child-head.7f9c54f6.svg";